// @ts-nocheck
import { useEffect, useState } from 'react';
import { Button, Paper, InputBase, IconButton, Tabs, Tab } from '@mui/material';
import { IconArrowRight, IconExport, IconSearch } from '../../../icons/Icon';
import styles from './kitchenindentdetails.module.scss';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import Accordion from './Accordion';
import Loader from '../../../components/loader/Loader';
import { useSelector } from 'react-redux';
import { formatCost } from '../../../utils/format';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { fetchCutOfTime, fetchKitchenIndent,fetchUpdateRequisitionDataIntoKIPP, removeMog, submitKitchenIndent } from '../../../services/kitchenIndentProductionPlanSlice';
import { toast } from 'react-toastify';
import { format } from 'date-fns/esm';
import InfoModal from '../../../components/commonComponent/InfoModal';
import { differenceInDays, set } from 'date-fns';
import { getFormattedDate, applyXlsxSheetStyles } from '../../../utils/helper';
import * as XLSX from 'xlsx-js-style';
import { fetchSites } from '../../../services/siteSlice';
import { RootState } from '../../../store/store';
import { titleStyle, headerStyle, sectionStyle, contentStyle, daypartStyle } from '../../../utils/constants';
import SingleSelect from '../../../components/commonComponent/SingleSelect';

const KitchenIndentDetails = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { params: ProductionPlanParams } = useSelector((state: any) => state.productionPlan);
  const isDisabled = ProductionPlanParams?.disableKI ?? false;

  const [value, setValue] = useState(0);
  const [openIndices, setOpenIndices] = useState<number[]>([0]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isDayBefore, setIsDayBefore] = useState<boolean>(false);
  const [kippLoading, setKippLoading] = useState<boolean>(false);
  const { kitchenIndent, loading } = useSelector((state: any) => state.kitchenIndentProduction);
  const { params, previousPlan } = useSelector((state: any) => state.productionPlan);
  const kitchenSectionOverallTotalCost: number = kitchenIndent[0]?.daypartmoglist?.length ? kitchenIndent[0]?.daypartmoglist?.map((daypart: any) => daypart?.totalcost ? daypart?.totalcost : 0)?.reduce((acc: number, num: number) => acc + num, 0) : 0;
  const kitchenSectionTotalCost: number = kitchenIndent[value]?.daypartmoglist?.length ? kitchenIndent[value]?.daypartmoglist?.map((daypart: any) => daypart?.totalcost ? daypart?.totalcost : 0)?.reduce((acc: number, num: number) => acc + num, 0) : 0;
  const cogsn = kitchenIndent[0]?.totalrevenue ? parseFloat(((kitchenSectionOverallTotalCost / kitchenIndent[0]?.totalrevenue) * 100).toFixed(2)) : 0;
  const showcostValue = localStorage.getItem('showcost');
  const roleId = Number(localStorage.getItem('roleId'));
  const sectorId = localStorage.getItem('sectorId');
  const regionId = Number(localStorage.getItem('regionid'));
  const userId = localStorage.getItem('userid');
  const [userData, setUserData] = useState<any>();
  const { sites } = useSelector((state: RootState) => state.site);
  const [selectedArticleType, setSelectedArticleType] = useState<string>('Perishables');
 const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  const articleTypeOptions = [
    { label: 'All', value: 'All' },
    { label: 'Perishables', value: 'Perishables' },
    { label: 'Non-Perishables', value: 'Non-Perishables' },    
    { label: 'Un–Mapped', value: '__NULL__' },
  ];

  const filterRecipesByArticleType = (recipesmoglist: any[] = []) => {
    if (selectedArticleType === 'All') return recipesmoglist;

    const normalizeArticleType = (value: any) =>
      String(value ?? '')
        .toLowerCase()
        .replace(/[^a-z]/g, '');

    return recipesmoglist.filter((recipe: any) => {
      const articleType = recipe?.shelflifecategory;
      if (selectedArticleType === '__NULL__') {
        return articleType === null || articleType === undefined || articleType === '' || articleType === '-' || String(articleType).toLowerCase() === 'null';
      }

      const normalizedArticleType = normalizeArticleType(articleType);
      const normalizedSelectedType = normalizeArticleType(selectedArticleType);

      if (normalizedSelectedType === 'perishables') {
        return normalizedArticleType.includes('perish') && !normalizedArticleType.includes('non');
      }

      if (normalizedSelectedType === 'nonperishables') {
        return normalizedArticleType.includes('non') && normalizedArticleType.includes('perish');
      }

      return normalizedArticleType === normalizedSelectedType;
    });
  };

  const getFilteredDayPartMog = (dayPartMog: any) => ({
    ...dayPartMog,
    recipesmoglist: filterRecipesByArticleType(dayPartMog?.recipesmoglist || []),
  });

  const getFilteredRecipesForExport = (recipesmoglist: any[] = []) =>
    filterRecipesByArticleType(recipesmoglist);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    if (userInfo) {
      const type = userInfo?.userdetails;
      setUserData(type);
    }
    dispatch(fetchSites(userInfo?.userdetails?.userid));
  }, []);

  // Toggle individual accordion sections
  const handleToggle = (index: number) => {
    setOpenIndices((prevIndices) => {
      return prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index) // Close if already open
        : [...prevIndices, index]; // Open if closed
      // const hasDish = kitchenIndent[value]?.daypartmoglist?.[index]?.recipesmoglist?.length > 0;
      // if (hasDish) {
      //   return [...new Set([...prevIndices, index])]; // Ensure unique indices
      // } else {
      //   return prevIndices.includes(index)
      //     ? prevIndices.filter((i) => i !== index) // Close if already open
      //     : [...prevIndices, index]; // Open if closed
      // }
    });
  };

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      const matchingIndices = kitchenIndent[value]?.daypartmoglist
        ?.map((daypart: any, index: number) =>
         filterRecipesByArticleType(daypart.recipesmoglist || [])?.some((recipe: any) =>
            recipe?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            recipe?.mogcode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            recipe?.aplname?.toLowerCase().includes(searchTerm.toLowerCase())
          ) ? index : null
        )
        ?.filter((index: number | null) => index !== null) || [];

      setOpenIndices(matchingIndices);
    }
  }, [searchTerm, kitchenIndent, value, selectedArticleType]);



  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // Expand all sections
  const handleExpandAll = () => {
    setOpenIndices(kitchenIndent[value]?.daypartmoglist?.map((__: any, index: number) => index));
  };

  // Collapse all sections
  const handleCollapseAll = () => {
    setOpenIndices([]); // 
  };

  const getKitchenIndent = () => {
    // Only call API if required parameters are available
    if (params?.menudate && params?.indentdayparts && params?.indentdayparts?.length > 0) {
      dispatch(fetchKitchenIndent({
        menudate: params?.menudate,
        daypartidlist: params?.indentdayparts
      }));
    }     
    
  }
    const getfetchUpdateRequisitionDataIntoKIPP = () => {
    // Only call API if required parameters are available
    if (params?.menudate && params?.indentdayparts && params?.indentdayparts?.length > 0) {
        setKippLoading(true);
        dispatch(fetchUpdateRequisitionDataIntoKIPP({
          menudate: params?.menudate,
          daypartidlist: params?.indentdayparts,
          IsItemWise: userInfo?.userdetails?.isitemwise,
          siteidlist:params?.siteidlist
        }))
          ?.unwrap()
          ?.then(() => {
            setKippLoading(false);
          })
          ?.catch((error) => {
            console.error("fetch update requisition data into KIPP API error::", error);
            setKippLoading(false);
          });
    }     
    
  }  

  useEffect(() => {    
    const payload = {
      sectorcode: sectorId,
      regionid: regionId,
      roleid: roleId,
      userid: userId,
      modulecode: "05"
    }
    dispatch(fetchCutOfTime(payload))
      ?.unwrap()
      ?.then((res) => {
        const laterDateTime = set(params?.menudate ? new Date(params?.menudate) : new Date(), {
          hours: res?.cutofftimehh || 24,
          minutes: res?.cutofftimemm || 0,
          seconds: 0,
        })
        const dayDiffCompare = !(differenceInDays(laterDateTime, new Date()) < res?.cutoffdays);
        setIsDayBefore(dayDiffCompare);
      })
      ?.catch((error) => console.error("fetch cutofdate API error::", error));
   // getKitchenIndent();
   getfetchUpdateRequisitionDataIntoKIPP();
  }, [params]); // Add params as dependency

  const handleDeleteMog = (kitchensectioncode: string, daypartcode: string, mogcode: string) => {
    dispatch(removeMog({
      menudate: params?.menudate,
      kitchensectioncode,
      mogcode,
      daypartcode
    })).unwrap().then((res: any) => {
      toast(res?.message, { type: "success" });
      getKitchenIndent();
    }).catch((error) => console.error(" remove mog API error::", error));
  }

  const handleSubmitKitchenIndent = () => {
    setOpenModal(prev => !prev)
    const payload: any = {
      menudate: params?.menudate,
    }
    dispatch(submitKitchenIndent(payload))?.unwrap()?.then(() => {
      toast(`Kitchen indent submitted successfully`, { type: "success" });
    }).catch((error) => console.error(" submit kitchen indent API error", error));
  }

  const isEditableCheck = (
    kitchensectioncode: string,
    previousPlan: boolean
  ) => {
    if (kitchensectioncode == "KTC-00000") {
      if (kitchenIndent?.length == 1) {
        if (previousPlan) {
          return roleId == 1 ? previousPlan : !previousPlan;
        } else {
          return isDayBefore;
        }
      } else {
        return false;
      }
    } else {
      if (previousPlan) {
        return roleId == 1 ? previousPlan : !previousPlan;
      } else {
        return isDayBefore;
      }
    }
  };

  function getUniqueDaypartNamesString(data: any) {
    const daypartNames = new Set(); // Use Set to store unique names

    data.forEach((kitchenSection: any) => {
      if (kitchenSection.daypartmoglist && Array.isArray(kitchenSection.daypartmoglist)) {
        kitchenSection.daypartmoglist.forEach((daypart: any) => {
          if (daypart.name) {
            daypartNames.add(daypart.name); // Add to Set to ensure uniqueness
          }
        });
      }
    });
    return Array.from(daypartNames).join(", "); // Convert Set to array and join as string
  }

  function getUniqueKitchenSectionNamesString(data: any) {
    const kitchenSectionNames = new Set(); // Use Set to store unique kitchen section names

    data.forEach((kitchenSection: any) => {
      if (kitchenSection.kitchensectionname) {
        kitchenSectionNames.add(kitchenSection.kitchensectionname); // Add unique names to Set
      }
    });

    return Array.from(kitchenSectionNames).join(", "); // Convert Set to array and join into a string
  }

  // Helper function to get excel data for specific sections organized by meal periods
  const getExcelDataBySection = (sectionNames: string[], startingIndex, rowIndexes) => {
    const filteredItems = (sites.length > 0 ?
      sites.map((obj: any) => obj.sitecode).join(", ") :
      ""
    );

    const filteredSections = kitchenIndent.filter(section => 
      sectionNames.some(name => section?.kitchensectionname?.toLowerCase()?.includes(name.toLowerCase()))
    );

    const issueTypes = getUniqueDaypartNamesString(filteredSections);
    const requestTypes = sectionNames.join(", ");
    const header = [['Site Code', 'Posting Date', 'Issue Type', 'Request Type', 'Issue area']]
    rowIndexes.push({
      index: startingIndex,
      style: 'header'
    })
    startingIndex++;
    const subInfo = [[userData?.usertype === "Non CPU" ? filteredItems : userData?.cpusitecode, `${getFormattedDate(params?.menudate, "dd-MMM-yy")}`, issueTypes, requestTypes, '']]
    startingIndex += 2;

    let excelData = [
      ...header,
      ...subInfo,
      ...[['']],
    ]

    // Get all unique daypart names from filtered sections for organizing meals
    const allDayparts = new Set();
    filteredSections.forEach(section => {
      section?.daypartmoglist?.forEach(daypart => {
        if (daypart.name) {
          allDayparts.add(daypart.name);
        }
      });
    });

    // Sort dayparts (you can customize this order)
    const sortedDayparts = Array.from(allDayparts).sort((a, b) => {
      const order = ['Breakfast', 'Lunch', 'Evening Snacks', 'Dinner'];
      const indexA = order.findIndex(meal => a.toLowerCase().includes(meal.toLowerCase()));
      const indexB = order.findIndex(meal => b.toLowerCase().includes(meal.toLowerCase()));
      
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.localeCompare(b);
    });

    // Process each daypart separately
    sortedDayparts.forEach((daypartName, daypartIndex) => {
      // Add daypart section header
      const daypartHeader = [[`${daypartName.toUpperCase()}`, '', '', '', '']]
      rowIndexes.push({
        index: startingIndex,
        style: 'section'
      })
      startingIndex++;

      const subHeading = [['Article Number', 'Article Description', 'UOM','Category Name', 'Article Type', 'Requested Quantity', 'Remark']]
      rowIndexes.push({
        index: startingIndex,
        style: 'header'
      })
      startingIndex++;

      excelData = [
        ...excelData,
        ...daypartHeader,
        ...subHeading
      ]

      // Process only items from this specific daypart (no aggregation - show individual quantities)
      filteredSections.forEach(section => {
        section?.daypartmoglist?.forEach(daypart => {
          if (daypart.name === daypartName) {
            getFilteredRecipesForExport(daypart?.recipesmoglist || [])?.forEach(item => {
              if (item?.articlenumber) {
                const content = [[
                  item?.articlenumber || "NA", 
                  item?.aplname || "NA", 
                  item?.apluom || "NA", 
                  item?.categoryname || 'NA',
                  item?.shelflifecategory || 'NA',
                  item?.revisedquantity || 0, 
                  ''
                ]]
                excelData = [
                  ...excelData,
                  ...content
                ]
                startingIndex++;
              }
            });
          }
        });
      });

      // Add spacing between dayparts
      if (daypartIndex < sortedDayparts.length - 1) {
        excelData = [...excelData, [['']]];
        startingIndex++;
      }
    });

    return excelData ?? [[]]
  }

  const getExcelDataCumulative = (startingIndex, rowIndexes) => {
    const filteredItems = (sites.length > 0 ?
      sites.map((obj: any) => obj.sitecode).join(", ") :
      ""
    );

    // Filter to include only the "Overall" section for the Overall sheet   
    const filteredKitchenIndent = kitchenIndent.filter(section => {
      const sectionName = section?.kitchensectionname?.toLowerCase();
      const isOverall = sectionName?.includes('overall');      
      return isOverall;
    });
    
    const issueTypes = getUniqueDaypartNamesString(filteredKitchenIndent)
    const requestTypes = getUniqueKitchenSectionNamesString(filteredKitchenIndent)
    const header = [['Site Code', 'Posting Date', 'Issue Type', 'Request Type', 'Issue area']]
    rowIndexes.push({
      index: startingIndex,
      style: 'header'
    })
    startingIndex++;
    const subInfo = [[userData?.usertype === "Non CPU" ? filteredItems : userData?.cpusitecode, `${getFormattedDate(params?.menudate, "dd-MMM-yy")}`, issueTypes, requestTypes, '']]
    startingIndex += 2;

    let excelData = [
      ...header,
      ...subInfo,
      ...[['']],
    ]

    // Get all unique daypart names for organizing meals (only from Overall section)
    const allDayparts = new Set();
    filteredKitchenIndent.forEach(section => {
      section?.daypartmoglist?.forEach(daypart => {
        if (daypart.name) {
          allDayparts.add(daypart.name);
        }
      });
    });

    // Sort dayparts (customize this order as needed)
    const sortedDayparts = Array.from(allDayparts).sort((a, b) => {
      const order = ['Breakfast', 'Lunch', 'Evening Snacks', 'Dinner'];
      const indexA = order.findIndex(meal => a.toLowerCase().includes(meal.toLowerCase()));
      const indexB = order.findIndex(meal => b.toLowerCase().includes(meal.toLowerCase()));
      
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.localeCompare(b);
    });

    // Process each daypart separately
    sortedDayparts.forEach((daypartName, daypartIndex) => {
      // Add daypart section header
      const daypartHeader = [[`${daypartName.toUpperCase()}`, '', '', '', '']]
      rowIndexes.push({
        index: startingIndex,
        style: 'section'
      })
      startingIndex++;

      const subHeading = [['Article Number', 'Article Description', 'UOM', 'Category Name', 'Article Type', 'Requested Quantity', 'Remark']]
      rowIndexes.push({
        index: startingIndex,
        style: 'header'
      })
      startingIndex++;

      excelData = [
        ...excelData,
        ...daypartHeader,
        ...subHeading
      ]

      const apllist = [];
      
      // Process only items from this specific daypart (only Overall section) - no aggregation
      filteredKitchenIndent.forEach(section => {
        section?.daypartmoglist?.forEach(daypart => {
          if (daypart.name === daypartName) {
            getFilteredRecipesForExport(daypart?.recipesmoglist || [])?.forEach(item => {
              if (item?.articlenumber) {
                const content = [[
                  item?.articlenumber || "NA", 
                  item?.aplname || "NA", 
                  item?.apluom || "NA", 
                  item?.categoryname || 'NA',
                  item?.shelflifecategory || 'NA',
                  item?.revisedquantity || 0, 
                  ''
                ]]
                excelData = [
                  ...excelData,
                  ...content
                ]
                startingIndex++;
              }
            });
          }
        });
      });

      // Add spacing between dayparts
      if (daypartIndex < sortedDayparts.length - 1) {
        excelData = [...excelData, [['']]];
        startingIndex++;
      }
    });

    return excelData ?? [[]]
  }

  const getMogList = (recipesmoglist: any, startingIndex, rowIndexes) => {
    const header = [["ID", "MOG Name", "Planned Qty (Kg)", "Revised Qty (Kg)", "APL", "APL UOM","Category Name", "Article Type", "APL Cost"]]
    rowIndexes.push({
      index: startingIndex + 1,
      style: 'header'
    })
    // startingIndex++;
    let combinedData: Array<any> = []
    combinedData = [
      ...header
    ]
    getFilteredRecipesForExport(recipesmoglist || [])?.map((recipe: any) => {
      if (recipe?.mogcode) {
        const data = [[`${recipe?.mogcode}`, `${recipe?.name}`, `${!recipe?.isdeletable ? recipe?.planquantity : "-"}`, `${recipe?.revisedquantity ? recipe?.revisedquantity : 0}`, `${recipe?.aplname || "NA"} (₹${recipe?.aplcost ?? 0})`, `${recipe?.apluom || "NA"}`,  `${recipe?.categoryname || "NA"}`,
            `${recipe?.shelflifecategory || "NA"}`, `${recipe?.cost ?? 0}`]]
        combinedData = [
          ...combinedData,
          ...data
        ]
        //startingIndex++;
      }
    })
    return combinedData;
  }

  const getMOGExcelData = (section: any, startingIndex, rowIndexes) => {
    let data = []
    section?.map((mog: any) => {
      const mealtimeHeader = [[`${mog?.name}`, ...Array(8).fill('')]]
      rowIndexes.push({
        index: startingIndex,
        style: 'daypart'
      })

      const excelData = getMogList(mog?.recipesmoglist, startingIndex, rowIndexes);

      startingIndex += excelData.length + 2;
      data = [
        ...data,
        ...mealtimeHeader,
        ...excelData,
        ...[['']]
      ]
    })
    return data
  }

  const handleExport = () => {
        
    // Check if kitchen indent data is available and valid
    if (!kitchenIndent || kitchenIndent.length === 0) {
      toast("No data is available for export", { type: "error" });
      return;
    }

    // Check if required parameters are available
    if (!params?.menudate) {
      toast("Menu date is required for export", { type: "error" });
      return;
    }

    try {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Helper function to create and style worksheet
      const createStyledWorksheet = (data, rowIndexes, sheetName) => {
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        worksheet["!cols"] = Array(10).fill({ wch: 20 });
        
        rowIndexes?.forEach((rowIndex => {
          // Apply the header style to all header cells
          for (let colIndex = 0; colIndex < 7; colIndex++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
            if (!worksheet[cellAddress]) {
              worksheet[cellAddress] = {};
            }
            switch (rowIndex?.style) {
              case 'title':
                worksheet[cellAddress].s = titleStyle;
                break;
              case 'header':
                worksheet[cellAddress].s = headerStyle;
                break;
              case 'section':
                worksheet[cellAddress].s = {
                  fill: sectionStyle.fill,
                  font: sectionStyle.font,
                  border: sectionStyle.border,
                  alignment: { horizontal: 'left', vertical: 'center' }
                };
                break;
              case 'content':
                worksheet[cellAddress].s = contentStyle;
                break;
              case 'daypart':
                worksheet[cellAddress].s = daypartStyle;
                break;
              default:
                break;
            }
          }
        }));
        
        if (worksheet['A2']) {
          worksheet['A2'].s = { alignment: { wrapText: true } };
        }

        // Center specific columns by header label (preserve section left alignment)
        try {
          const targetHeaders = [
            'Site Code',
            'Posting Date',
            'Issue Type',
            'Request Type',
            'Issue area',
            'Article Number',
            'UOM',
            'Article Type',
            'Requested Quantity'
          ];
          const maxWidth = Math.max(...data.map((r: any[]) => (r ? r.length : 0)), 1);
          const targetColsSet = new Set<number>();
          const sectionRowsSet = new Set((rowIndexes || []).filter(ri => ri.style === 'section').map(ri => ri.index));
          for (let r = 0; r < data.length; r++) {
            const row = data[r];
            if (!Array.isArray(row)) continue;
            for (let c = 0; c < maxWidth; c++) {
              const cellVal = row[c] !== undefined && row[c] !== null ? String(row[c]).trim() : '';
              if (targetHeaders.includes(cellVal)) targetColsSet.add(c);
            }
          }
          const targetCols = Array.from(targetColsSet);
          if (targetCols.length > 0) {
            for (let r = 0; r < data.length; r++) {
              if (sectionRowsSet.has(r)) continue;
              for (const c of targetCols) {
                const addr = XLSX.utils.encode_cell({ r, c });
                if (!worksheet[addr]) worksheet[addr] = { v: data[r] && data[r][c] !== undefined ? data[r][c] : '' };
                if (!worksheet[addr].s) worksheet[addr].s = {};
                const existingAlign = worksheet[addr].s.alignment || {};
                worksheet[addr].s.alignment = { ...existingAlign, horizontal: 'center', vertical: 'center' };
              }
            }
          }
        } catch (err) {
          // ignore alignment errors for export
        }

        // Auto-fit Article Description column (index 1)
        try {
          const totalRowsForAuto = data.length;
          const computedMaxWidth = Math.max(...data.map((r: any[]) => (r ? r.length : 0)), 1);
          worksheet["!cols"] = worksheet["!cols"] || Array(Math.max(10, computedMaxWidth)).fill({ wch: 20 });
          let maxLen = 0;
          for (let rr = 0; rr < totalRowsForAuto; rr++) {
            const a = XLSX.utils.encode_cell({ r: rr, c: 1 });
            if (worksheet[a] && worksheet[a].v !== undefined && worksheet[a].v !== null) {
              const l = String(worksheet[a].v).length;
              if (l > maxLen) maxLen = l;
            }
          }
          const target = Math.min(Math.max(maxLen + 5, 10), 120);
          worksheet["!cols"][1] = { wch: target };
        } catch (err) {
          // ignore
        }

        // Left-align Article Description values for data rows (preserve headers)
        try {
          const styledRowSet = new Set((rowIndexes || []).map((r) => r.index));
          const skipRows = new Set<number>();
          for (let r = 0; r < data.length; r++) {
            const row = data[r];
            if (!Array.isArray(row)) continue;
            for (let c = 0; c < row.length; c++) {
              if (String(row[c]).trim() === 'Posting Date') {
                if (r + 1 < data.length) skipRows.add(r + 1);
              }
            }
          }
          for (let rr = 0; rr < data.length; rr++) {
            if (styledRowSet.has(rr)) continue;
            if (skipRows.has(rr)) continue;
            const addr = XLSX.utils.encode_cell({ r: rr, c: 1 });
            if (!worksheet[addr] || worksheet[addr].v === '' || worksheet[addr].v === undefined) continue;
            worksheet[addr].s = worksheet[addr].s || {};
            const existingAlign = worksheet[addr].s.alignment || {};
            worksheet[addr].s.alignment = { ...existingAlign, horizontal: 'left', vertical: 'center' };
          }
        } catch (err) {
          // ignore
        }

        // Auto-fit Category Name column (index 3) and left-align data cells
        try {
          const hasCategoryHeader = (data || []).some((row: any[]) => Array.isArray(row) && row.some(cell => String(cell || '').trim() === 'Category Name'));
          if (hasCategoryHeader) {
            const totalRows = data.length;
            worksheet["!cols"] = worksheet["!cols"] || Array(Math.max(10, Math.max(...data.map((r: any[]) => (r ? r.length : 0))))).fill({ wch: 20 });
            let maxLenCat = 0;
            for (let rr = 0; rr < totalRows; rr++) {
              const a = XLSX.utils.encode_cell({ r: rr, c: 3 });
              if (worksheet[a] && worksheet[a].v !== undefined && worksheet[a].v !== null) {
                const l = String(worksheet[a].v).length;
                if (l > maxLenCat) maxLenCat = l;
              }
            }
            const targetCat = Math.min(Math.max(maxLenCat + 5, 10), 120);
            worksheet["!cols"][3] = { wch: targetCat };

            const styledRowSet2 = new Set((rowIndexes || []).map((r) => r.index));
            for (let rr = 0; rr < totalRows; rr++) {
              if (styledRowSet2.has(rr)) continue;
              const addr = XLSX.utils.encode_cell({ r: rr, c: 3 });
              if (!worksheet[addr]) {
                const val = data[rr] && data[rr][3] !== undefined ? data[rr][3] : undefined;
                if (val === undefined || val === null || val === '') continue;
                worksheet[addr] = { v: val };
              }
              worksheet[addr].s = worksheet[addr].s || {};
              const existing = worksheet[addr].s.alignment || {};
              if (existing.horizontal === 'center') continue;
              worksheet[addr].s.alignment = { ...existing, horizontal: 'left', vertical: 'center' };
            }
          }
        } catch (err) {
          // ignore
        }

        // Apply borders + suppress gridlines
        applyXlsxSheetStyles(worksheet, rowIndexes, data.length, 7);
        
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.substring(0, 30));
      };

      // Create Overall sheet (existing cumulative data)
      let startingIndex = 0;
      let rowIndexes = [];
      const cumulativeExportData = getExcelDataCumulative(startingIndex, rowIndexes);      
      createStyledWorksheet(cumulativeExportData, rowIndexes, "Overall");

      // Create Event sheet
      const eventSections = kitchenIndent.filter(section => 
        section?.kitchensectionname?.toLowerCase()?.includes('event')
      );
      
      
      if (eventSections.length > 0) {
        startingIndex = 0;
        rowIndexes = [];
        const eventExportData = getExcelDataBySection(['Event'], startingIndex, rowIndexes);        
        createStyledWorksheet(eventExportData, rowIndexes, "Event");
      }

      // Create Bakery sheet
      const bakerySections = kitchenIndent.filter(section => 
        section?.kitchensectionname?.toLowerCase()?.includes('bakery')
      );
     
      
      if (bakerySections.length > 0) {
        startingIndex = 0;
        rowIndexes = [];
        const bakeryExportData = getExcelDataBySection(['Bakery'], startingIndex, rowIndexes);        
        createStyledWorksheet(bakeryExportData, rowIndexes, "Bakery");
      }

      // Export the workbook to an Excel file
      XLSX.writeFile(workbook, `Kitchen Indent_APL_${getFormattedDate(params?.menudate, "dd-MMM-yy")}.xlsx`);
      toast("File downloaded successfully!", { type: "success" });
    } catch (error) {      
      toast("Export failed. Please try again.", { type: "error" });
    }
  }

  const getTotalperDay = (plan: any, type: String) => {
    switch (type) {
      case 'cost':
        return plan?.daypartmoglist?.reduce((total: any, item: any) => total + (item.totalcost || 0), 0)
      case 'revenue':
        return plan?.daypartmoglist?.reduce((total: any, item: any) => total + (item.totalcost || 0), 0)
      default:
        break;
    }
  }

  const handleMOGExport = () => {
    // Check if kitchen indent data is available and valid
    if (!kitchenIndent || kitchenIndent.length === 0) {
      toast("No data is available for export", { type: "error" });
      return;
    }

    // Check if required parameters are available
    if (!params?.menudate) {
      toast("Menu date is required for export", { type: "error" });
      return;
    }

    try {
      const filteredSites = (sites.length > 0 ?
        sites.map((obj: any) => obj.sitecode).join(", ") :
        ""
      );
      const workbook = XLSX.utils.book_new();
      kitchenIndent.map((section: any, index: any) => {
        let startingIndex = 0;
        let rowIndexes = [{
          index: startingIndex,
          style: 'title'
        }]
        startingIndex++;
        let mogExportData: any = [];
        const header = userData?.usertype === "Non CPU" ? [[filteredSites]] : [[`BOQ (Store Requsition) - ${userData?.cpusitename || ''}-${userData?.cpusitecode || ''}`, ...Array(8).fill('')]]
        const dateHeader = [[`Date: ${getFormattedDate(params?.menudate, "EEE, dd-MMM-yy")}`, '', index === 0 ? `Total cost per day ₹${getTotalperDay(section, 'cost')}` : '', '', index === 0 ? `Total revenue per day ₹${section?.totalrevenue}` : '']]
        mogExportData = [
          ...mogExportData,
          ...header,
          ...dateHeader,
          ...[['']],
        ]
        startingIndex += 2;
        const sectionHeader = [[`${section?.kitchensectionname}`, ...Array(8).fill('')]]
        rowIndexes.push({
          index: startingIndex,
          style: 'section'
        })
        startingIndex++;
        const combinedData = getMOGExcelData(section?.daypartmoglist, startingIndex, rowIndexes)
        mogExportData = [
          ...mogExportData,
          ...sectionHeader,
          ...combinedData,
          ...[[''], [''], ['']]
        ]
        startingIndex += 3;
        // Create a new workbook and worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(mogExportData);
        worksheet["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, // Merge A1:I1
          { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }, // Merge A2:B2
          { s: { r: 1, c: 2 }, e: { r: 1, c: 3 } }, // Merge C2:D2
          { s: { r: 1, c: 4 }, e: { r: 1, c: 5 } }, // Merge E2:F2
        ];
        worksheet["!cols"] = Array(10).fill({ wch: 20 });

        // Ensure merged header/date rows have borders and aligned style
        for (let col = 0; col <= 8; col++) {
          const cellAddr = XLSX.utils.encode_cell({ r: 0, c: col });
          if (!worksheet[cellAddr]) worksheet[cellAddr] = {};
          worksheet[cellAddr].s = worksheet[cellAddr].s || {};
          worksheet[cellAddr].s.border = {
            top: { style: 'thin', color: { rgb: 'FF000000' } },
            bottom: { style: 'thin', color: { rgb: 'FF000000' } },
            left: { style: 'thin', color: { rgb: 'FF000000' } },
            right: { style: 'thin', color: { rgb: 'FF000000' } },
          };
          worksheet[cellAddr].s.alignment = { horizontal: 'left', vertical: 'left' };
        }
        for (let col = 0; col <= 8; col++) {
          const dateCellAddr = XLSX.utils.encode_cell({ r: 1, c: col });
          if (!worksheet[dateCellAddr]) worksheet[dateCellAddr] = {};
          worksheet[dateCellAddr].s = worksheet[dateCellAddr].s || {};
          worksheet[dateCellAddr].s.border = {
            top: { style: 'thin', color: { rgb: 'FF000000' } },
            bottom: { style: 'thin', color: { rgb: 'FF000000' } },
            left: { style: 'thin', color: { rgb: 'FF000000' } },
            right: { style: 'thin', color: { rgb: 'FF000000' } },
          };
          worksheet[dateCellAddr].s.alignment = { horizontal: 'left', vertical: 'left' };
        }

        rowIndexes?.forEach((rowIndex => {
          // Apply the header style to all header cells
          for (let colIndex = 0; colIndex < 9; colIndex++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
            if (!worksheet[cellAddress]) {
              worksheet[cellAddress] = {};
            }
            switch (rowIndex?.style) {
              case 'title':
                worksheet[cellAddress].s = titleStyle;
                break;
              case 'header':
                worksheet[cellAddress].s = headerStyle;
                break;
              case 'section':
                worksheet[cellAddress].s = {
                  fill: sectionStyle.fill,
                  font: sectionStyle.font,
                  border: sectionStyle.border,
                  alignment: { horizontal: 'left', vertical: 'center' }
                };
                break;
              case 'content':
                worksheet[cellAddress].s = contentStyle;
                break;
              case 'daypart':
                worksheet[cellAddress].s = daypartStyle;
                break;
              default:
                break;
            }
          }
        }))

        // Header row alignment refinements
        try {
          for (let r = 0; r < mogExportData.length; r++) {
            const firstAddr = XLSX.utils.encode_cell({ r, c: 0 });
            if (worksheet[firstAddr] && (worksheet[firstAddr].v === 'ID' || worksheet[firstAddr].v === "ID")) {
              worksheet[firstAddr].s = worksheet[firstAddr].s || {};
              worksheet[firstAddr].s.alignment = { horizontal: 'left', vertical: 'center' };

              const headerCenterCols = [2, 3, 5, 7, 8];
              headerCenterCols.forEach((c) => {
                const addr = XLSX.utils.encode_cell({ r, c });
                if (!worksheet[addr]) worksheet[addr] = {};
                worksheet[addr].s = worksheet[addr].s || {};
                worksheet[addr].s.alignment = { horizontal: 'center', vertical: 'center' };
              });
              break;
            }
          }
        } catch (err) {
          // ignore
        }

        // Data row alignment refinements
        try {
          const styledRowSet = new Set((rowIndexes || []).map(r => r.index));
          const totalRows = mogExportData.length;
          const centerCols = new Set([0, 2, 3, 5, 7, 8]);
          for (let r = 0; r < totalRows; r++) {
            if (styledRowSet.has(r)) continue;
            const firstCell = XLSX.utils.encode_cell({ r, c: 0 });
            if (!worksheet[firstCell] || worksheet[firstCell].v === '' || worksheet[firstCell].v === undefined) continue;
            for (let c = 0; c <= 8; c++) {
              const addr = XLSX.utils.encode_cell({ r, c });
              if (!worksheet[addr]) worksheet[addr] = {};
              worksheet[addr].s = worksheet[addr].s || {};
              const horiz = centerCols.has(c) ? 'center' : (worksheet[addr].s.alignment && worksheet[addr].s.alignment.horizontal) || 'left';
              worksheet[addr].s.alignment = { horizontal: horiz, vertical: 'center' };
            }
          }
        } catch (err) {
          // ignore
        }

        // Apply borders + suppress gridlines
        applyXlsxSheetStyles(worksheet, rowIndexes, mogExportData.length, 9);

        // Auto-fit APL and Category Name columns
        try {
          const totalRowsForAuto = mogExportData.length;
          worksheet["!cols"] = worksheet["!cols"] || Array(10).fill({ wch: 20 });
          [4, 6].forEach((colIndex) => {
            let maxLen = 0;
            for (let rr = 0; rr < totalRowsForAuto; rr++) {
              const a = XLSX.utils.encode_cell({ r: rr, c: colIndex });
              if (worksheet[a] && worksheet[a].v !== undefined && worksheet[a].v !== null) {
                const l = String(worksheet[a].v).length;
                if (l > maxLen) maxLen = l;
              }
            }
            const target = Math.min(Math.max(maxLen + 5, 10), 120);
            worksheet["!cols"][colIndex] = { wch: target };
          });
        } catch (err) {
          // ignore
        }

        XLSX.utils.book_append_sheet(workbook, worksheet, `${section?.kitchensectionname.replace(/[^a-zA-Z0-9]/g, ' ').substring(0, 30).trim()}`);
      })
      // Export the workbook to an Excel file
      XLSX.writeFile(workbook, `Kitchen_Indent_${getFormattedDate(params?.menudate, "dd-MMM-yy")}.xlsx`);
      toast("File downloaded successfully!", { type: "success" });
    } catch (error) {     
      toast("Export failed. Please try again.", { type: "error" });
    }
  }

  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper className={`search-input mr-12 ${styles.search}`}>
            <InputBase placeholder="Search MOG/APL" value={searchTerm} onChange={(e) => setSearchTerm(e?.target?.value?.trim())} />
            <IconButton type="button" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
          {showcostValue === 'true' &&
            <div className="flex align-items-center total-cost">
              <div className='cost'><span>Total Cost</span>: ₹ {formatCost(kitchenSectionTotalCost, 2)}</div><span className={styles.divide}>|</span><div className='cost'><span>Overall Cost</span>: ₹ {formatCost(kitchenSectionOverallTotalCost, 2)}</div><span className={styles.divide}>|</span><div className='cost'><span>COGSn%: </span>{cogsn}</div>
            </div>}
        </div>
        <div className="button-wrap flex align-items-center">
          <Button className="link-btn" disableRipple onClick={handleExpandAll}>
            Expand All
          </Button>
          <span className='divider'></span>
          <Button className='link-btn' disableRipple onClick={handleCollapseAll}>
            Collapse All
          </Button>
          <span className="divider"></span>
          <button onClick={() => handleExport()} className="cmenu-btn">
            <IconExport /> Export Article Data
          </button>
          <span className="divider"></span>
          <button onClick={() => handleMOGExport()} className="cmenu-btn">
            <IconExport /> Export MOG Data
          </button>
          <Button className="primary-btn btn-right ml-16" onClick={() => setOpenModal(prev => !prev)} disabled={isDisabled} disableRipple>
            Submit <span className='ml-4 flex align-items-center'><IconArrowRight /></span>
          </Button>
          {openModal &&
            <InfoModal
              open={openModal}
              handleClose={() => setOpenModal(prev => !prev)}
              handleOk={() => handleSubmitKitchenIndent()}
              title="Submit"
              description="All changes will be saved. Are you sure you want to submit?"
              closeText="No"
              submitText="Yes"
            />}
        </div>
      </div>

      <div className={`flex justify-content-between ${styles.tabbingDataWrap}`}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tabs"
          className="tabs-wrapper"
        >
          {kitchenIndent?.length > 0 && kitchenIndent?.map((kitchenSection: any, index: number) => {
            return <Tab key={index} label={kitchenSection?.kitchensectionname} sx={{ color: kitchenSection?.kitchensectionname?.toLowerCase()?.includes('event') && "#1AD55B !important" || kitchenSection?.kitchensectionname?.toLowerCase()?.includes('bakery') && "#F9B959 !important" }} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} disableRipple />
          })}
        </Tabs>
          <div style={{ minWidth: '240px', marginLeft: 'auto', marginRight: '12px', marginBottom: '8px' }}>
            <SingleSelect
              //label="Select Article Type"
              options={articleTypeOptions}
              value={selectedArticleType}
              onChange={(e) => setSelectedArticleType(String(e.target.value))}
              placeholder="Select Article Type"
            />
          </div> 
        <div className="right flex align-itmes-center menu-period">
          <strong>Menu Date:</strong>
          {params ? <span>{format(new Date(params?.menudate), 'dd-MMM-yyyy')}</span> : '--'}
        </div>
      </div>
      <div className="inner-contant kitchen-dashboard">
        {kitchenIndent?.length > 0 && kitchenIndent?.map((kitchenSection: any, index: number) => {
          return (<CustomTabPanel key={index} value={value} index={index}>
            {!!kitchenSection?.daypartmoglist?.length ?
              kitchenSection?.daypartmoglist?.map((dayPartMog: any, dayPartIndex: number) => {
                const filteredDayPartMog = getFilteredDayPartMog(dayPartMog);
                return (
                  <Accordion
                    key={dayPartIndex}
                    openIndices={openIndices}
                    handleToggle={handleToggle}
                    dayPartIndex={dayPartIndex}
                    dayPartMog={filteredDayPartMog}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    kitchenSectionCode={kitchenSection?.kitchensectioncode}
                    isEditable={isEditableCheck(kitchenSection?.kitchensectioncode, previousPlan)}
                    handleDeleteMog={handleDeleteMog}
                  />
                )
              }) : <h4>No meals available</h4>}
          </CustomTabPanel>)
        })}
      </div>
      {(loading || kippLoading) && <Loader />}
    </div>
  );
};

export default KitchenIndentDetails;
